var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cargo-shipment-bag-summary"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Cargo Shipment Summary")])])])]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_vm._v("AWB/MPS No.:")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "AWB",
      "value": "AWB",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "AWB")
    },
    on: {
      "__c": function($event) {
        _vm.shipmentType = "AWB"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "AWB"
    }
  }, [_vm._v("AWB ")]), _vm._v("     \n                        "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "MPS",
      "value": "MPS",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "MPS")
    },
    on: {
      "__c": function($event) {
        _vm.shipmentType = "MPS"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "MPS"
    }
  }, [_vm._v("MPS")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentMPS),
      expression: "parentMPS"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ParentMPS')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please enter AWB No/MPS No.",
      "name": "ParentMPS",
      "id": "ParentMPS"
    },
    domProps: {
      "value": (_vm.parentMPS)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getParentMPSDetails($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentMPS = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.ParentMPSError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ParentMPSErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-23px",
      "margin-right": "12px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getParentMPSDetails
    }
  }, [_vm._v("Show Shipment Log")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "-11px"
    }
  }, [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('bagNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "Bag No",
      "id": "bagNo"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getBagDetails($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.ParentAWBError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ParentAWBErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getBagDetails
    }
  }, [_vm._v("Show Bag Log")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "36px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])]), _vm._v(" "), (_vm.showParentMPSDetailsTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ParentMPS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Final Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Last Modified Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ParentMPSDetails), function(MPSData, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.ParentMPS))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": _vm.showShipmentTranscationDetails
      }
    }, [_vm._v(_vm._s(MPSData.ShippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.Status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.ServiceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.OriginHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.CurrentHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.FinalDestinationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.PackageDetails.Weight.BillableWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(MPSData.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(MPSData.CreatedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(MPSData.LastModifedDate)))])])
  }), _vm._v(" "), (_vm.ParentMPSDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "19"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showBagdetailsTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Seal No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Origin Hubname")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Current Hubname")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Hubname")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Physical Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Chargeable Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Volumetric Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Category")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created By ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipments Details")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Log")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagDetails.BagDetails), function(data, index) {
    return (_vm.bagDetails.BagDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sealno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("BagCategory")(data.isparentbag)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          _vm.showShipmentDetails(data.sealno)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          _vm.showModalOnClickBag(_vm.bagDetails)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.bagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showbagShipmentDetailsModal == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.showbagShipmentDetailsModal),
      callback: function($$v) {
        _vm.showbagShipmentDetailsModal = $$v
      },
      expression: "showbagShipmentDetailsModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closebagShipmentDetailsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent Bagno")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No/Shippingid")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Current Hubid")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagShipmentDetails), function(data, index) {
    return (_vm.bagShipmentDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno) + _vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))])]) : _vm._e()
  }), _vm._v(" "), (_vm.bagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showModalBag == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.showModalBag),
      callback: function($$v) {
        _vm.showModalBag = $$v
      },
      expression: "showModalBag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Audit Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBagModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Process Location Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.auditLog), function(data, index) {
    return (_vm.auditLog.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processlocation))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processlocationname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.bagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showShipmentTranscationTable == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Transactions Log"
    },
    model: {
      value: (_vm.showShipmentTranscationTable),
      callback: function($$v) {
        _vm.showShipmentTranscationTable = $$v
      },
      expression: "showShipmentTranscationTable"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transactions Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Current Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.transcationDetails), function(data, index) {
    return (_vm.transcationDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ProcessLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CreatedBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.CreatedDate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.transcationDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.transcationDetailsForMPSTable == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Transactions Log"
    },
    model: {
      value: (_vm.transcationDetailsForMPSTable),
      callback: function($$v) {
        _vm.transcationDetailsForMPSTable = $$v
      },
      expression: "transcationDetailsForMPSTable"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transactions Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Current Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.transcationDetailsForMPS), function(data, index) {
    return (_vm.transcationDetailsForMPS.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ProcessLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CreatedBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.CreatedDate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.transcationDetailsForMPS.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.invoicedetailsflag == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Invoice Details"
    },
    model: {
      value: (_vm.invoicedetailsflag),
      callback: function($$v) {
        _vm.invoicedetailsflag = $$v
      },
      expression: "invoicedetailsflag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Invoice Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeInvoiceDetailsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Invoice Value ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EBN Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EBN Expiry Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View Invoice Image")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.invoiceDetails), function(data, index) {
    return (_vm.invoiceDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoiceno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoicevalue))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "disabled": data.ewaybillsrnumber == null || data.ewaybillsrnumber == _vm.NULL
      },
      on: {
        "click": function($event) {
          _vm.showEBNDetails(data.ewaybillsrnumber)
        }
      }
    }, [_vm._v(_vm._s(data.ewaybillsrnumber))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.ebnexpirydate)))]), _vm._v(" "), (data.ocrimagepath) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "colspan": "2"
      },
      on: {
        "click": function($event) {
          _vm.openOcrImage(data.ocrimagepath)
        }
      }
    }, [_vm._v("View Image")]) : _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("No Image Found")])]) : _vm._e()
  }), _vm._v(" "), (_vm.invoiceDetails.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ebndetailsflag == true),
      expression: "ebndetailsflag==true"
    }]
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('legend', [_vm._v("EBN Details \n                      "), _c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "539px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.PrintEBN
    }
  }, [_vm._v("Print EBN")]), _vm._v("    \n                      "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer",
      "float": "right"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeEbnDetailsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printebnData"
    }
  }, _vm._l((_vm.printebn), function(item) {
    return _c('EbnDetails', {
      key: item.AWB,
      attrs: {
        "selectedData": item
      }
    })
  }))], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showPaperBagTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "120px",
      "margin-top": "20px"
    }
  }, [_c('legend', [_vm._v("Paper Work Tracking")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Paper Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent MPS Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("THC No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("THC Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Paper Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("MPS Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Final Destination")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.paperbagdetails), function(data, index) {
    return (_vm.paperbagdetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentmpsstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.thcno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.thcdate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.finaldestinationName))])]) : _vm._e()
  }), _vm._v(" "), (_vm.paperbagdetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showAWBTrack) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "fit-content",
      "margin-top": "20px"
    }
  }, [_c('legend', [_vm._v("AWB Tracking")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Origin Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Destination Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Consignee(Name and address)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Invoice Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Last Modified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AWB Verification Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Appointment Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Delivery Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Delivery Rescheduled Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showShipmentDetails(_vm.AWBtrackData)
      }
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.parentMPS))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.clientName) + " (" + _vm._s(_vm.AWBtrackData.clientid) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.status))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.shipmentstatus))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.originhubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.originpincode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.currenthubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.finaldestinationName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.shippincode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.consigneeName) + " (" + _vm._s(_vm.AWBtrackData.consigneeAddress) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.pdd))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showInvoiceDetails(_vm.AWBtrackData.parentMPS)
      }
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.invoicecount))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.createddate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.lastmodifieddate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.awbverificationtime)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.appointmentdeliverydate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.deliverydate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.rescheduleddate))])]), _vm._v(" "), (_vm.AWBtrackData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showShipmentTrack) ? _c('div', {
    staticClass: "content"
  }, [_c('legend', {
    staticStyle: {
      "position": "absolute",
      "width": "98%"
    }
  }, [_vm._v("MPS Tracking - MPS Count: " + _vm._s(_vm.mpscount) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Final Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Last Modified Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentTrackData), function(data, index) {
    return (_vm.shipmentTrackData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentMPS))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          _vm.showShipmentTranscationDetailsForMPSTrack(data.shippingid)
        }
      }
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.servicetype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.finaldestinationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.AWBtrackData.lastmodifieddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.shipmentTrackData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.awbdetailsflag == true) ? _c('b-modal', {
    attrs: {
      "id": "obj",
      "size": "lg",
      "title": "AWB Details"
    },
    model: {
      value: (_vm.awbdetailsflag),
      callback: function($$v) {
        _vm.awbdetailsflag = $$v
      },
      expression: "awbdetailsflag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("AWB Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAWBDetailsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Physical Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Shipment Value")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("New FLM Shipment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Self Drop Shipment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Self Collect Shipment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lat/Long")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("POD")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.AWBtrackData.servicetype))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.chargeableWeight))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.physicalWeight))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.volumetricWeight))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.awbdata.declaredvalue))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.awbdata.ordertype))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.awbdata.isnewsys))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.awbdata.selfdrop))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.awbdata.selfcollect))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLatLongDetails(_vm.AWBtrackData.parentMPS)
      }
    }
  }, [_c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-map-marker"
  })])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showPODDetails(_vm.AWBtrackData.parentMPS)
      }
    }
  }, [_vm._v("POD")])]), _vm._v(" "), (_vm.awbdata.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.latlongdetailsflag == true),
      expression: "latlongdetailsflag==true"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Lat/Long Details "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeLatLongDetailsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("AWB Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Latitude ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Longitude")])])]), _vm._v(" "), _c('tbody', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _vm._l((_vm.latlongdetails), function(data, index) {
    return (_vm.latlongdetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row",
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(data.awbstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(data.latitude))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(data.longitude))])]) : _vm._e()
  }), _vm._v(" "), (_vm.latlongdetails.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showpod == true),
      expression: "showpod==true"
    }]
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("POD Images")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePODImages
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticStyle: {
      "font-size": "15px",
      "margin-left": "0.5rem"
    }
  }, [_vm._v("Click on the image to view it")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.podimgArr), function(item) {
    return _c('div', [(item) ? _c('img', {
      staticStyle: {
        "cursor": "pointer",
        "width": "65px",
        "margin-left": "2rem",
        "height": "65px"
      },
      attrs: {
        "src": item,
        "alt": "NO Image",
        "title": "Open Image"
      },
      on: {
        "click": function($event) {
          _vm.openImage(item)
        }
      }
    }) : _vm._e()])
  }))])])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.fieldImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.fieldImg
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "close Image"
    },
    on: {
      "click": function($event) {
        _vm.closePODModal('myModalImg' + _vm.fieldImg)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "-1px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.fieldcaption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.fieldImg,
      "src": _vm.podimgArr
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])]), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImgOcr",
      "id": 'ocrimgid' + _vm.fieldImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'OcrImg' + _vm.fieldImg
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "close Image"
    },
    on: {
      "click": function($event) {
        _vm.closeOcrImg('OcrImg' + _vm.fieldImg)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "-1px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'OcrCaptionImg' + _vm.OcrFieldCaption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'ocrimg' + _vm.fieldImg
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39c1af9a","hasScoped":true}!./src/modules/report/views/BagShipmentQuery/BagShipmentQuery.component.html
// module id = 2080
// module chunks = 3